import { useDispatch, useSelector } from 'react-redux';
import useRouter from './useRouter';
import routes from '../utils/variables/routes';
import Cookies from '../cookies/cookies';
import {
  manuallyChosenAlpha2Storage,
  userSettingsExpireTimeHrs,
} from '../utils/variables';
import { createRelativeUrl } from '../utils/functions';

const useCountryChange = () => {
  const router = useRouter();
  const allLocations = useSelector(state => state.locations.allLocations);

  return newAlpha2 => {
    const newCountryValue = newAlpha2;
    const newLocation = allLocations?.find(x => x.alpha2 === newCountryValue);

    if (newLocation) {
      Cookies.setCookie(
        manuallyChosenAlpha2Storage,
        newCountryValue,
        userSettingsExpireTimeHrs,
      );

      const queryObject = {
        ...router?.query,
        c: newAlpha2,
      };
      const relativeUrl = createRelativeUrl({
        path: router.pathname,
        queryObject,
      });

      setTimeout(function() {
        router.replace(relativeUrl);
      }, 50);
    } else {
      window.alert('No Valid Territory Selected');
    }
  };
};

export default useCountryChange;
